import * as React from 'react';
import { Messages } from '../../../codegen/Localize';
import { LogoService } from '../../../ts/services/LogoService';
import { ServiceLocator } from '../../ServiceLocator';

export const SignInLogo: React.FunctionComponent = () => {
  const logoService = ServiceLocator.get<LogoService>('LogoService');
  const logo = logoService.getSignInLogo();
  const logoStyle: React.CSSProperties = {
    maxWidth: logo.width,
    maxHeight: logo.height,
  };

  return <img
    src={logo.image}
    title={logo.title}
    alt={Messages.signinLogo()}
    style={logoStyle}
    role="img"
    data-tb-test-id="tableau-server-logo"
  />;
};
